import { type IVmapAdBreak } from '@sxmp/ad-sdk-web';

import { type IActionOf, type IMapOf } from '../../../../types';
import { Actions, CompanionActions } from '../constants';
import { type IAdCreatedPayload, type IAdTrack, type IIncrementIndexPayload } from '../types';

export function adStarted(): IActionOf<Actions.AD_STARTED> {
  return { type: Actions.AD_STARTED };
}

export function adEnded(): IActionOf<Actions.AD_ENDED> {
  return { type: Actions.AD_ENDED };
}

export function adSkipped(): IActionOf<Actions.AD_SKIPPED> {
  return { type: Actions.AD_SKIPPED };
}

export function adCreated(
  track: IMapOf<IAdTrack> | IAdTrack,
): IActionOf<Actions.AD_CREATED, IAdCreatedPayload> {
  return {
    type: Actions.AD_CREATED,
    data: { track },
  };
}

export function adDestroyed(): IActionOf<Actions.AD_DESTROYED> {
  return { type: Actions.AD_DESTROYED };
}

export function handleTileLoaded(): IActionOf<CompanionActions.TILE_LOADED> {
  return {
    type: CompanionActions.TILE_LOADED,
  };
}

export function handleCompanionLoaded(): IActionOf<CompanionActions.COMPANION_LOADED> {
  return {
    type: CompanionActions.COMPANION_LOADED,
  };
}

export function handleCompanionClicked(): IActionOf<CompanionActions.COMPANION_CLICKED> {
  return {
    type: CompanionActions.COMPANION_CLICKED,
  };
}

export function incrementIndex(
  adBreak: IVmapAdBreak,
): IActionOf<Actions.INCREMENT_INDEX, IIncrementIndexPayload> {
  return {
    type: Actions.INCREMENT_INDEX,
    data: { adBreak },
  };
}
